import request from '@/config/axios'

export type BizMode = 'platform' | 'self'

export interface ProductVO {
  moduleCode: string
  title: string
  icon: string
  /** 模块卡片图标图片，来自 adminCard.iconUrl */
  iconUrl?: string
  description: string
  sort: number
  /** 两模式较大试用天，用于是否显示试用按钮 */
  trialDays: number
  trialDaysPlatform: number | null
  trialDaysSelf: number | null
  /** 展示价（已开通=当前模式，未开通=平台；正常模块=标准价） */
  priceMonthly: number | null
  priceYearly: number | null
  priceMonthlyPlatform: number | null
  priceYearlyPlatform: number | null
  priceMonthlySelf: number | null
  priceYearlySelf: number | null
  bizMode?: BizMode | null
  /** true=双模式须选经营模式；false=正常模块 biz_mode=NULL */
  bizModeRequired?: boolean
  /** 内部租户：免购 */
  internalTenant?: boolean
  tenantStatus: 'NOT_OPENED' | 'TRIAL' | 'ACTIVE' | 'EXPIRED'
  expireTime: number
  daysRemaining: number
  progressPercent: number
}

export interface ModePricing {
  mode: 'platform' | 'self'
  pricingId: number
  planName: string
  trialDays: number
  priceMonthly: number
  priceYearly: number
}

export interface OrderRespVO {
  orderId: number
  payOrderId: number
  payStatus: number
  tenantStatus: string
}

/** 获取当前租户产品列表 */
export function getTenantProducts(): Promise<ProductVO[]> {
  return request.get({
    url: '/system/tenant-module/products',
    headers: { ignoreError: true }
  })
}

/** 试用开通（正常模块可不传 bizMode） */
export function trialModule(moduleCode: string, bizMode?: BizMode | null): Promise<void> {
  return request.post({
    url: '/system/tenant-module/trial',
    data: bizMode ? { moduleCode, bizMode } : { moduleCode }
  })
}

/** 内部租户开通（双模式传 bizMode；计费周期与购买一致：1月付 2年付） */
export function openInternalModule(
  moduleCode: string,
  bizMode: BizMode | null | undefined,
  billingCycle: 1 | 2
): Promise<void> {
  return request.post({
    url: '/system/tenant-module/open-internal',
    data: {
      moduleCode,
      billingCycle,
      ...(bizMode ? { bizMode } : {})
    }
  })
}

/** 创建购买/续费订单（双模式模块需传 mode） */
export function createModuleOrder(data: {
  moduleCode: string
  bizMode?: BizMode | null
  billingCycle: 1 | 2
}): Promise<OrderRespVO> {
  return request.post({ url: '/system/tenant-module/create-order', data })
}

/** 查询模块订单状态 */
export function getOrderStatus(orderId: number): Promise<OrderRespVO> {
  return request.get({ url: '/system/tenant-module/order-status', params: { orderId } })
}

/** 当前租户某模块已绑定业务模式（未开通/已过期返回 null） */
export function getModuleBizMode(moduleCode: string): Promise<BizMode | null> {
  return request.get({ url: '/system/tenant-module/biz-mode', params: { moduleCode } })
}

// ==================== 模块定价管理 ====================

export interface PricingVO {
  id?: number
  moduleCode: string
  mode?: string
  planName: string
  trialDays?: number
  trialDaysPlatform: number
  trialDaysSelf: number
  priceMonthly?: number
  priceYearly?: number
  priceMonthlyPlatform: number
  priceYearlyPlatform: number
  priceMonthlySelf: number
  priceYearlySelf: number
  /** 1=双模式 0=正常模块 */
  bizModeRequired?: number
  status: number
}

/** 获取所有模块定价列表 */
export function getPricingList(): Promise<PricingVO[]> {
  return request.get({ url: '/saas-billing/tenant-module/pricing/list' })
}

/** 保存模块定价 */
export function savePricing(data: PricingVO): Promise<void> {
  return request.post({ url: '/saas-billing/tenant-module/pricing/save', data })
}
